import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
  FormControlLabel,
  Switch
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFlask, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types'

const TestPromptDialog = ({
  open,
  onClose,
  onTest,
  automationName
}) => {
  const [testEmail, setTestEmail] = useState('')
  const [actualSend, setActualSend] = useState(false)

  const handleTest = () => {
    if (actualSend && !testEmail.trim()) return
    onTest(testEmail.trim() || '', actualSend)
    handleClose()
  }

  const handleClose = () => {
    setTestEmail('')
    setActualSend(false)
    onClose()
  }

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ style: { backgroundColor: 'var(--color-card-bg)', color: 'var(--color-text-primary)' } }}
    >
      <DialogTitle style={{ color: 'var(--color-text-primary)' }}>
        <Box display="flex" alignItems="center">
          <FontAwesomeIcon icon={faFlask} style={{ marginRight: 8, color: '#ff9800' }} />
          Test Automation - {automationName}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box mb={3}>
          <Typography variant="body2" color="textSecondary" paragraph>
            Test this automation to see which campaigns would trigger and optionally send actual test emails.
          </Typography>
          
          <Typography variant="body2" color="textSecondary" paragraph>
            Enter your email address where test notifications should be sent:
          </Typography>
        </Box>

        <TextField
          autoFocus
          margin="dense"
          label={actualSend ? "Test Email Address (Required)" : "Test Email Address (Optional)"}
          type="email"
          fullWidth
          value={testEmail}
          onChange={(e) => setTestEmail(e.target.value)}
          placeholder="your.email@example.com"
          required={actualSend}
          error={testEmail && !isValidEmail(testEmail)}
          helperText={
            testEmail && !isValidEmail(testEmail) 
              ? 'Please enter a valid email address' 
              : actualSend 
                ? 'Required for sending actual test emails'
                : 'Leave empty to just see which campaigns would trigger'
          }
          InputProps={{
            startAdornment: <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: 8, color: 'var(--color-text-secondary)' }} />
          }}
        />

        <Box mt={2}>
          <FormControlLabel
            control={
              <Switch
                checked={actualSend}
                onChange={(e) => setActualSend(e.target.checked)}
                color="primary"
              />
            }
            label={
              <Box>
                <Typography variant="body2">
                  Send actual test emails
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {actualSend 
                    ? 'Test emails will be sent to the address above for campaigns that trigger'
                    : 'Only show test results - no emails will be sent'
                  }
                </Typography>
              </Box>
            }
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button 
          onClick={handleTest} 
          color="primary" 
          variant="contained"
          disabled={
            (actualSend && (!testEmail.trim() || !isValidEmail(testEmail))) ||
            (testEmail && !isValidEmail(testEmail))
          }
        >
          Run Test
        </Button>
      </DialogActions>
    </Dialog>
  )
}

TestPromptDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onTest: PropTypes.func.isRequired,
  automationName: PropTypes.string
}

export default TestPromptDialog